module.exports = __webpack_public_path__ + "static/media/bot1.ffe44f42.png";